import React from "react";

const ABOUT_IMG = `${process.env.PUBLIC_URL}/images/about-lakeview.jpg`;

const PRESS = [
  { name: "Eco-News", img: `${process.env.PUBLIC_URL}/images/press-econews.jpg` },
  { name: "East Coast", img: `${process.env.PUBLIC_URL}/images/press-eastcoast.jpg` },
  { name: "BOS Home", img: `${process.env.PUBLIC_URL}/images/press-bos.png` },
  { name: "Featured Press", img: `${process.env.PUBLIC_URL}/images/press-selection.jpg` },
];

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-28 md:py-40 relative"
    >
      <div
        aria-hidden
        className="absolute left-0 right-0 top-0 h-[1px]"
        style={{ backgroundColor: "rgba(200,184,154,0.22)" }}
      />
      <div className="container-editorial grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-center">
        <div className="md:col-span-7 reveal">
          <div className="relative overflow-hidden" style={{ aspectRatio: "16 / 11" }}>
            <img
              src={ABOUT_IMG}
              alt="A studio Brehaut project overlooking the lake"
              className="absolute inset-0 w-full h-full object-cover"
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>

        <div className="md:col-span-5 reveal">
          <p
            className="text-[11px] uppercase font-body mb-6"
            style={{ color: "#3a7d7b", letterSpacing: "0.36em" }}
          >
            — Our Approach
          </p>
          <h2
            className="font-display leading-[1.04] tracking-[-0.018em] mb-10"
            style={{ fontSize: "clamp(2rem, 4.2vw, 4rem)", fontWeight: 400 }}
          >
            The beauty is in the <em className="italic">detail</em>.
          </h2>

          <div
            className="space-y-6 font-body text-base md:text-[17px] leading-[1.85] max-w-xl"
            style={{ color: "hsl(var(--foreground) / 0.85)" }}
          >
            <p>
              studio Brehaut provides comprehensive architectural services — predesign,
              schematic studies, municipal approvals, design development, construction
              drawings, engineering and special consultant coordination, and field review —
              for residential, commercial, and institutional projects, from small renovations
              to new construction.
            </p>
            <p>
              Our team strives to give our clients inspired, sustainable designs that meet
              exacting tastes and practical needs. We take the time to study a site and
              understand the surroundings, and we develop 3D models to show how sunlight
              will affect spaces and how different finishes, materials, furniture, and
              landscaping options will be impacted.
            </p>
            <p>
              We work closely with our clients to ensure they have a full understanding of
              each design and are active participants in the process.
            </p>
          </div>
        </div>
      </div>

      <div className="container-editorial mt-24 md:mt-32 reveal">
        <p
          className="text-[10px] md:text-[11px] uppercase font-body mb-8"
          style={{ color: "hsl(var(--foreground) / 0.55)", letterSpacing: "0.36em" }}
        >
          Featured In
        </p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {PRESS.map((p) => (
            <div
              key={p.name}
              className="relative overflow-hidden bg-foreground/[0.03]"
              style={{ aspectRatio: "4 / 5" }}
              data-testid={`press-${p.name.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <img
                src={p.img}
                alt={p.name}
                className="absolute inset-0 w-full h-full object-cover"
                loading="lazy"
                decoding="async"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
